import { combineReducers } from "redux";

import { surchargesDetails } from "./reducer.surcharges"
const surchargeReducers = combineReducers({

  surchargesDetails

})
export default surchargeReducers;
